import { useMutation } from '@tanstack/react-query'
import { api } from '@/lib/api'

/**
 * Response from the Twilio token endpoint
 */
export interface TwilioTokenResponse {
  identity: string
  token: string
}

/**
 * Parameters for fetching a Twilio token
 */
export interface TwilioTokenParams {
  identity: string
  assistantId: number
}

/**
 * Query keys for Twilio token queries
 */
export const twilioKeys = {
  all: ['twilio'] as const,
  token: (params: TwilioTokenParams) =>
    [...twilioKeys.all, 'token', params] as const,
}

/**
 * Fetch a Twilio Voice access token for browser-based calling
 */
async function fetchTwilioToken(
  params: TwilioTokenParams
): Promise<TwilioTokenResponse> {
  const { identity, assistantId } = params
  const response = await api.post<TwilioTokenResponse>(
    `/twilio/token?identity=${identity}&assistant_id=${assistantId}`
  )
  return response.data
}

/**
 * Hook for fetching Twilio Voice token
 *
 * Uses mutation pattern since tokens are short-lived and need to be refreshed
 */
export function useTwilioToken() {
  return useMutation({
    mutationFn: fetchTwilioToken,
  })
}

export default useTwilioToken
